import { Component } from "@angular/core";

@Component({
    selector: "app-layout",
    // C3-2 (R18): mat-sidenav-container → vng-sidenav (no drawer projected —
    // [opened]="false" collapses the empty <aside> to width:0, matching
    // today's behavior of having no <mat-sidenav> child at all). `:host`
    // targets the vng-sidenav element directly (it's a direct child of this
    // component's own template, so no ::ng-deep needed for it); the nested
    // .vng-sidenav__content lives in vng-sidenav's OWN template though, so
    // reaching it needs ::ng-deep.
    styles: [
        ":host vng-sidenav {z-index: 1000;} :host ::ng-deep .vng-sidenav__content {padding: 0;}"
    ],
    templateUrl: "./auth-layout.component.html",
    standalone: false
})
export class AuthLayoutComponent {}
